export default __webpack_public_path__ + "static/media/ellipse_icon.7afb1b14.svg";